export default "__VITE_ASSET__Z$evr0BE__"